<template>
  <div class="jiejuefangan home jjfa">
    <div id="nav" class="header">
      <head-top></head-top>
      <div class="fangan-banner">
        <div class="fangan-banner-left">
          <div class="fangan-banner-tab">
            <div
              class="banner-item"
              v-for="(item, index) in bannerTab"
              :key="index"
              :class="{ selected: item.isSelected }"
              @mouseenter="bannerCheck(item, index)"
            >
              {{ item.name }}
            </div>
          </div>
        </div>
        <div class="fangan-banner-right">
          <div
            class="banner-content"
            :class="{
              selected1: bannerTab[0].isSelected,
              selected2: bannerTab[1].isSelected,
              selected3: bannerTab[2].isSelected
            }"
          >
            <div class="banner-title">{{ bannerInfo[bannerIndex].name }}</div>
            <div class="banner-bottom">
              <div
                class="banner-items"
                v-for="(item, index) in bannerInfo[bannerIndex].titleList"
                :key="index"
              >
                <div>{{ item.title }}</div>
                <span>{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="fangan-main">
      <div class="fangan-problem">
        <div class="fangan-title">传统方式的问题</div>
        <div class="fangan-problem-items">
          <div
            class="fangan-problem-item"
            v-for="(item, index) in problemList"
            :key="index"
          >
            <div style="height:110px;margin-top:16px;"></div>
            <svg class="icon hide-icon" aria-hidden="true">
              <use :xlink:href="'#' + item.icon" />
            </svg>
            <svg class="icon hover-icon" aria-hidden="true">
              <use :xlink:href="'#' + item.hover" />
            </svg>
            <div class="fangan-problem-title">{{ item.title }}</div>
            <div class="fangan-problem-content">{{ item.content }}</div>
          </div>
        </div>
      </div>

      <div class="fangan-advantage">
        <div class="fangan-title">聚师傅的优势</div>
        <div class="fangan-advantage-list">
          <div
            class="fangan-advantage-content"
            v-for="(item, index) in advantageList"
            :key="index"
          >
            <div
              class="fangan-advantage-info"
              :class="{ right: (index + 1) % 2 == 0 }"
            >
              <div class="fangan-advantage-top">
                0{{ index + 1 }}
                <div class="fangan-advantage-top-title">{{ item.title }}</div>
              </div>
              <div
                class="fangan-advantage-bottom"
                v-for="(it, ind) in item.infoList"
                :key="ind"
              >
                {{ it }}
              </div>
            </div>
            <div class="fangan-advantage-img">
              <img :src="item.img" alt />
            </div>
          </div>
        </div>
      </div>

      <div class="home-coop">
        <div class="home-coop-main">
          <div class="home-coop-tit">
            <span>聚师傅的功能</span>
          </div>
          <div class="home-coop-cont">
            <ul>
              <li
                class="home-coop-item"
                v-for="(item, index) in coopArr"
                :key="index"
              >
                <div class="home-coop-item-main">
                  <div class="home-coop-icon">
                    <svg aria-hidden="true">
                      <use class="icon" :xlink:href="'#' + item.icon" />
                    </svg>
                  </div>
                  <div class="home-coop-goOrder">{{ item.text }}</div>
                  <div class="home-coop-text">{{ item.text }}</div>
                </div>
              </li>
            </ul>
            <!-- <div class="home-coop-more">
              <span class="home-coop-more-text">查看更多品类</span>
              <i class="iconfont iconicon_kind_more"></i>
            </div> -->
          </div>
        </div>
      </div>

      <div class="home-join">
        <div class="home-service-tit">
          加入聚师傅平台，共同打造行业服务新规范
        </div>
        <div class="home-join-cont">
          <ul>
            <li
              class="home-join-item"
              v-for="(item, index) in joinArr"
              :key="index"
              @click="goPage(item)"
            >
              <div class="home-join-item-main"></div>
              <svg aria-hidden="true">
                <use class="icon" :xlink:href="'#' + item.icon" />
              </svg>
              <span>{{ item.text }}</span>
              <i class="iconfont joinJt iconjiantou_big"></i>
            </li>
          </ul>
        </div>
      </div>

      <div class="fangan-file">
        <div class="fangan-title">帮助文档</div>
        <div class="fangan-file-info">
          <div
            class="fangan-file-item"
            v-for="(item, index) in activeNames"
            :key="index"
            v-if="index < 8"
            @click="goHelp(item)"
          >
            {{ item.title }}
          </div>
        </div>
        <div class="fangan-file-more" @click="openHelp()">
          查看更多
          <svg class="icon" aria-hidden="true">
            <use xlink:href="#iconjiantou_banner" />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import headTop from "./../../components/headTop";
export default {
  components: {
    headTop
  },
  data() {
    return {
      bannerTab: [
        { name: "企业端解决方案", isSelected: true },
        { name: "师傅端解决方案", isSelected: false },
        { name: "消费者解决方案", isSelected: false }
      ],
      bannerInfo: [
        {
          name: "共同打造行业服务新规范",
          titleList: [
            { title: "订单管理", name: "中国大型云服务平台" },
            { title: "费用管理", name: "全程数百个网点" },
            { title: "商品管理", name: "中国大型云服务平台" }
          ]
        },
        {
          name: "助您轻松实现个人梦想",
          titleList: [
            { title: "接单", name: "中国大型云服务平台" },
            { title: "上门安装", name: "全程数百个网点" },
            { title: "收取报酬", name: "资金全程托管" }
          ]
        },
        {
          name: "共同打造行业服务新规范",
          titleList: [
            { title: "查看订单", name: "中国大型云服务平台" },
            { title: "资金托管", name: "保障双方利益" },
            { title: "师傅信息", name: "师傅全员实名认证" }
          ]
        }
      ],
      bannerIndex: 0,
      problemList: [
        {
          icon: "iconfuwufeiyong_nor",
          hover: "iconfuwufeiyong_hov",
          title: "服务费用高",
          content:
            "行业没有统一的计费标准，安装师傅凭个人判断漫天要价，消费者无议价空间"
        },
        {
          icon: "iconzhiliangbuwending_nor",
          hover: "iconzhiliangbuwending_hov",
          title: "质量不稳定",
          content: "师傅大多未经培训，无专业知识，服务不规范，无法保证服务水准"
        },
        {
          icon: "iconshijianbukekong_nor",
          hover: "iconshijianbukekong_act",
          title: "时间不可控",
          content:
            "配送、安装的时间需要以安装师傅的时间为准，消费者只能协调自己的时间配合"
        },
        {
          icon: "iconshouhou_nor",
          hover: "iconshouhou_hov",
          title: "无法保证售后",
          content: "安装师傅通常不对售后提供保障，安装遗留问题难以解决"
        }
      ],
      advantageList: [
        {
          title: "覆盖区域广 区域内师傅密度大",
          img: require("../../assets/img/pic_youshi_01.png"),
          infoList: [
            "聚师傅在北京、上海、成都等地已经拥有了完备的地面服务团队",
            "每个辖区内都有足够多的师傅保证即时的响应",
            "师傅都备有专业的器材设备，保证稳定的安装质量"
          ]
        },
        {
          title: "完善的服务监管制度",
          img: require("../../assets/img/pic_youshi_02.png"),
          infoList: [
            "师傅所属辖区内有专业的管理机构进行质量监督",
            "每一次安装都需要消费者给出评价才可以获得对应的奖励，差评者扣钱",
            "安装师傅全部实名认证，平台管理员全程监督每一笔订单"
          ]
        },
        {
          title: "资金管理保证您的消费透明",
          img: require("../../assets/img/pic_youshi_03.png"),
          infoList: [
            "资金全程托管，消费者确认满意后才放款",
            "一笔订单状态清晰可见，充值、退款简单便捷",
            "所有资金情况轻松管理"
          ]
        }
      ],
      joinArr: [
        {
          icon: "iconicon_home_hongyingchang1",
          text: "加入服务商团队"
        },
        {
          icon: "iconicon_home_shifu1",
          text: "加入师傅团队"
        }
      ],
      coopArr: [
        {
          icon: "icongongneng_dingdanguanli",
          text: "订单管理"
        },
        {
          icon: "icongongneng_feiyongguanli",
          text: "费用管理"
        },
        {
          icon: "iconshangpinguanli",
          text: "商品管理"
        },
        {
          icon: "iconjieduan",
          text: "接单管理"
        },
        {
          icon: "iconyanhuopaizhao",
          text: "验货拍照"
        },
        {
          icon: "iconwanchengdingdan",
          text: "完成订单"
        },
        {
          icon: "iconshouqubaochou",
          text: "收取报酬"
        },
        {
          icon: "iconchakandingdan",
          text: "查看订单"
        },
        {
          icon: "iconchakanshifuxinxi",
          text: "查看师傅信息"
        },
        {
          icon: "iconpingjiashifu",
          text: "评价师傅"
        }
      ],
      fileTextList: [
        { title: "如何注销账号?" },
        { title: "安装效果不满意怎么办？" },
        { title: "收不到验证码怎么办?" },
        { title: "我的个人信息是否安全我的个人信息否方式方法" },
        { title: "无法注册账号怎么办？" },
        { title: "师傅未按时安装到场怎么办？" },
        { title: "怎么投诉安装师傅？" }
      ],
      activeNames: []
    };
  },
  mounted() {
    this.getHelp();
  },
  methods: {
    bannerCheck(item, index) {
      this.bannerIndex = index;
      for (let i of this.bannerTab) {
        i.isSelected = false;
      }
      item.isSelected = true;
    },
    goPage(item) {
      if (item.text == "加入服务商团队") {
        this.$router.push({ path: "/service_ruzhu" });
      }
      if (item.text == "加入师傅团队") {
        this.$router.push({ path: "/ruzhu" });
      }
    },
    // 获取帮助中心
    getHelp() {
      let _this = this;
      this.$fetch(
        `/common/api/article?pageIndex=1&pageSize=50&typeCode=help`
      ).then(res => {
        if (res.code == 0) {
          _this.activeNames = res.data.pageList;
        } else {
          this.$message(res.message);
        }
      });
    },
    // 跳转帮助中心
    goHelp(item) {
      this.$router.push({
        name: "help",
        params: {
          title: item.title
        }
      });
    },
    // 跳转帮助中心
    openHelp() {
      this.$router.push({
        name: "help"
      });
    }
  }
};
</script>
<style lang="scss">
.jjfa {
  #nav {
    .head-rightBottom {
      .fangan {
        border-bottom: 2px solid #fff;
      }
    }
  }
}
.jiejuefangan {
  #nav {
    background: url("../../assets/img/banner.jpg") no-repeat;
    background-size: cover;
    height: 500px;
    background-position: center;
    margin-top: 110px;

    .fangan-banner {
      width: 1200px;
      margin: 0 auto;
      display: flex;

      .fangan-banner-left {
        overflow: hidden;
        width: 392px;
        .fangan-banner-tab {
          width: 352px;
          height: 340px;
          background: rgba(52, 85, 211, 0.5);
          margin-top: 120px;
          margin-left: 20px;
          padding: 30px 0;
          .banner-item {
            height: 80px;
            color: rgba($color: #ffffff, $alpha: 0.9);
            font-size: 24px;
            text-align: center;
            line-height: 80px;
            cursor: pointer;
            position: relative;
          }
          .selected {
            width: 392px;
            margin-left: -20px;
            background: #fff;
            color: #3455d3;
            font-weight: bold;
          }
          .banner-item:hover {
            background: rgba(49, 71, 152, 1);
          }
          .banner-item:nth-child(2) {
            margin-top: 20px;
            margin-bottom: 20px;
          }
          .selected:hover {
            background: #fff;
            color: #3455d3;
          }
          .selected::after {
            content: "“";
            position: absolute;
            width: 24px;
            height: 24px;
            left: 71px;
            top: 16px;
            font-size: 41px;
            line-height: 1;
          }
        }
      }
      .fangan-banner-right {
        margin-left: 75px;
        padding-top: 166px;
        box-sizing: border-box;
        .banner-content {
          width: 594px;
          height: 237px;
          background: rgba(52, 85, 211, 1);
          // margin-top: 166px;
          position: relative;
          .banner-title {
            padding-top: 30px;
            margin-left: 55px;
            color: #fff;
            font-size: 30px;
            font-weight: bold;
            height: 40px;
            line-height: 40px;
            position: relative;
          }
          .banner-title::after {
            content: "";
            background: #ffffff;
            width: 122px;
            height: 2px;
            position: absolute;
            top: 84px;
            left: 0;
          }
        }
        .banner-content::after {
          content: "";
          position: absolute;
          border-bottom: 30px solid #3455d3;
          border-left: 47px solid transparent;
          border-top: 0px solid transparent;
          border-right: 0px solid transparent;
          left: -47px;
          top: 18px;
          transition: cubic-bezier(0.08, 0.82, 0.68, 1.06);
          transition-duration: 400ms;
        }
        .selected1::after {
          top: 18px;
        }
        .selected2::after {
          top: 98px;
        }
        .selected3::after {
          top: 183px;
        }
        .banner-bottom {
          margin-top: 69px;
          display: flex;
          .banner-items {
            width: 198px;
            height: 128px;
            & > div {
              width: 89px;
              height: 40px;
              background: rgba(255, 255, 255, 1);
              color: #3455d3;
              font-size: 16px;
              padding: 12px 0;
              line-height: 1;
              text-align: center;
              margin: 0 auto;
              margin-top: 24px;
              position: relative;
            }
            & > div:after {
              content: "";
              position: absolute;
              border-bottom: 13px solid transparent;
              border-left: 15px solid rgba(255, 255, 255, 0.7);
              border-right: 0px solid transparent;
              bottom: -13px;
              right: 0;
            }
            & > span {
              margin-top: 22px;
              display: block;
              height: 18px;
              font-size: 12px;
              line-height: 18px;
              text-align: center;
              color: #fff;
            }
          }
        }
      }
    }
  }
  .fangan-main {
    margin-top: 80px;
    .fangan-title {
      height: 48px;
      font-size: 32px;
      color: rgba(47, 49, 51, 1);
      line-height: 48px;
      text-align: center;
    }
    .fangan-problem {
      width: 1200px;
      margin: 0 auto;
      .fangan-problem-items {
        display: flex;
        margin-top: 40px;
      }
      .fangan-problem-item {
        width: 291px;
        height: 318px;
        margin-right: 12px;
        text-align: center;
        position: relative;
        .icon {
          width: 110px;
          height: 110px;
          position: absolute;
          left: 31.7%;
          top: 16px;
          transition: cubic-bezier(0.08, 0.82, 0.68, 1.06);
          transition-duration: 400ms;
        }
        .hover-icon {
          // display: none;
          opacity: 0;
        }
        .fangan-problem-title {
          height: 30px;
          font-size: 20px;
          color: rgba(47, 49, 51, 1);
          line-height: 30px;
          margin-top: 24px;
        }
        .fangan-problem-content {
          height: 52px;
          font-size: 14px;
          color: rgba(144, 147, 153, 1);
          line-height: 26px;
          margin-top: 10px;
          padding: 0 17px;
        }
      }
      .fangan-problem-item:hover {
        box-shadow: 0px 5px 14px 0px rgba(18, 31, 80, 0.08);
        transition: cubic-bezier(0.08, 0.82, 0.68, 1.06);
        transition-duration: 400ms;
        .hover-icon {
          // display: inline-block;
          opacity: 1;
        }
        .hide-icon {
          // display: none;
          opacity: 0;
        }
      }
      .fangan-problem-item:last-child {
        margin-right: 12px;
      }
    }
    .fangan-advantage {
      padding-top: 24px;
      width: 1200px;
      margin: 0 auto;
      .fangan-advantage-list {
        margin-top: 48px;
        .fangan-advantage-content {
          height: 296px;
          position: relative;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 65px;
          .fangan-advantage-info {
            width: 594px;
            height: 224px;
            .fangan-advantage-top {
              height: 100px;
              padding: 16px 30px;
              display: flex;
              align-items: center;
              font-size: 50px;
              font-weight: 100;
              color: rgba(52, 85, 211, 1);
              .fangan-advantage-top-title {
                font-size: 20px;
                font-weight: 500;
                margin-left: 23px;
                position: relative;
              }
              .fangan-advantage-top-title:after {
                content: "";
                position: absolute;
                width: calc(100% + 7px);
                height: 19px;
                background: #d8e0ff;
                left: 0;
                top: 20px;
                z-index: -1;
              }
            }
            .fangan-advantage-bottom {
              height: 20px;
              font-size: 12px;
              color: rgba(94, 96, 102, 1);
              line-height: 20px;
              margin-left: 119px;
              margin-bottom: 12px;
              position: relative;
            }
            .fangan-advantage-bottom:after {
              content: "";
              position: absolute;
              width: 6px;
              height: 6px;
              border-radius: 50%;
              background: #909399;
              left: -12px;
              top: 6.5px;
            }
          }
          .fangan-advantage-img {
            width: 483px;
            height: 296px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .right {
            position: absolute;
            right: 0;
          }
        }
        .fangan-advantage-content:last-child {
          margin-bottom: 0;
        }
      }
    }
    .home-join-cont,
    .home-coop {
      transform: none;
      opacity: 1;
    }
    .home-coop {
      background: url("../../assets/img/pic_banner2.jpg") no-repeat;
      background-size: cover;
      background-position: center;
    }
    .fangan-file {
      width: 100%;
      margin-top: 100px;
      background: #f5f7fc;
      padding: 40px 0 30px 0;
      .fangan-file-info {
        width: 795px;
        margin: 0 auto;
        margin-top: 69px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        position: relative;
        padding-left: 100px;
        .fangan-file-item {
          width: 291px;
          height: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 1;
          font-size: 16px;
          white-space: nowrap;
          margin-top: 24px;
          cursor: pointer;
          &:hover {
            color: #3455d3;
          }
        }
        .fangan-file-item:nth-child(1),
        .fangan-file-item:nth-child(2) {
          margin-top: 0;
        }
      }
      .fangan-file-info:after,
      .fangan-file-info:before {
        content: "";
        position: absolute;
        top: -24px;
        width: 27px;
        height: 5px;
        background: #3455d3;
      }
      .fangan-file-info:after {
        left: 100px;
      }
      .fangan-file-info:before {
        left: 504px;
      }
      .fangan-file-more {
        margin: 0 auto;
        width: 85px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 40px;
        font-size: 16px;
        cursor: pointer;
      }
      .fangan-file-more:hover {
        width: 90px;
        color: #3455d3;
        transition: cubic-bezier(0.08, 0.82, 0.68, 1.06);
        transition-duration: 400ms;
      }
    }
  }
}
</style>
